import { useAppSelector } from "@assessment/store/store";
import { Question } from "@assessment/types/assessmentOngoing";
import GetHeroIcon from "@lxp-app/utils/getHeroIcon";
import { useTranslation } from "react-i18next";

interface QnDisplay {
  question: Question;
  totalQuestionsInSection: number;
  sectionId: string;
}

const QuestionDisplay = ({
  question,
  totalQuestionsInSection,
  sectionId
}: QnDisplay) => {
  const { t } = useTranslation();
  const preAssessmentData = useAppSelector(
    (state) => state.AssessmentSlice.preAssessmentData
  );

  const showQuestionTitle = useAppSelector(
    (state) =>
      state.AssessmentSlice.preAssessmentData.questionConfig.showQuestionTitle
  );

  const assessmentProgress = useAppSelector(
    (state) => state.AssessmentSlice.assessmentProgress
  );
  const questionFlagged =
    assessmentProgress[sectionId].questions[question.questionId].flagged;

  return (
    <>
      <div className="space-y-10">
        <div>
          <div className="flex flex-col lg:flex-row items-center justify-between mb-2">
            <h3 className="text-base font-semibold leading-5 text-secondary">
              {t("assessment.objective.questionCounter")}{" "}
              {question.orderInSection} / {totalQuestionsInSection}
            </h3>

            {preAssessmentData?.questionConfig?.showQuestionMarks && (
              <h3 className="text-base sm:text-lg font-bold leading-5 text-secondary">
                {t("assessment.objective.marks")} {question?.maxMarks}
              </h3>
            )}
          </div>
          <div className="flex flex-row gap-2 mb-2">
            {showQuestionTitle && question?.questiontitle && (
              <div className="text-xl font-bold py-2">
                {question?.questiontitle}
              </div>
            )}
            {questionFlagged && (
              <GetHeroIcon
                name="FlagIcon"
                className="w-5 h-5 text-[#AA6207] flex-shrink-0"
              />
            )}
          </div>
        </div>
        <div
          dangerouslySetInnerHTML={{ __html: question?.problemStatement }}
          className="no-select"
        />
      </div>
    </>
  );
};

export default QuestionDisplay;
